const time = {
    parseDate(date) {
        let parsed = new Date(date)
        const arr = [parsed.getFullYear(), parsed.getMonth() < 9 ? '0' + (parsed.getMonth() + 1) : parsed.getMonth() + 1, parsed.getDate() < 10 ? '0' + parsed.getDate() : parsed.getDate()]
        return arr.join('-')
    }
}
export default time;